import { action, makeObservable, observable } from 'mobx';
import { PowerAndBalancing } from 'src/integration/types/PowerAndBalancing';

class PowerAndBalancingStore {
  @observable powerAndBalancing: PowerAndBalancing[] = [];
  @observable version: number = Date.now();

  @action setPowerAndBalancingData = (data: SimpleObject[]) => {
    this.powerAndBalancing = data as PowerAndBalancing[];
    this.version = Date.now();
  };

  constructor() {
    makeObservable(this);
  }
}

export default PowerAndBalancingStore;
